// Cena 1 — Visão geral do menu (áudio ~22s)
// O cursor passeia pelos itens REAIS do menu lateral enquanto a narração
// apresenta cada área. Sidebar em spotlight (fundo desfocado + anel).
// Finaliza com clique visual no botão do tutorial + toast fixo.
export default async function menu(ctx) {
	// garante que a sidebar e o primeiro item existem antes de mirar
	await ctx.waitFor("[data-tour='sidebar']", 5000);
	await ctx.waitFor("[data-tour='menu-dashboard']", 4000);

	ctx.spotlight("[data-tour='sidebar']");
	await ctx.wait(1300);

	// passeio: cursor pousa em cada item real, pausa ~1.2s
	await ctx.cursorTo("[data-tour='menu-dashboard']", { duration: 1000 });
	await ctx.wait(1250);

	await ctx.waitFor("[data-tour='menu-tickets']", 2000);
	await ctx.cursorTo("[data-tour='menu-tickets']", { duration: 650 });
	await ctx.wait(1250);

	await ctx.waitFor("[data-tour='menu-contacts']", 2000);
	await ctx.cursorTo("[data-tour='menu-contacts']", { duration: 650 });
	await ctx.wait(1250);

	await ctx.waitFor("[data-tour='menu-quickanswers']", 2000);
	await ctx.cursorTo("[data-tour='menu-quickanswers']", { duration: 650 });
	await ctx.wait(1250);

	await ctx.waitFor("[data-tour='menu-connections']", 2000);
	await ctx.cursorTo("[data-tour='menu-connections']", { duration: 650 });
	await ctx.wait(1250);

	// itens de administrador: só visita se estiverem visíveis
	// (rectOf é síncrono — não trava a cena para perfis sem acesso)
	if (ctx.rectOf("[data-tour='menu-users']")) {
		await ctx.cursorTo("[data-tour='menu-users']", { duration: 650 });
		await ctx.wait(1100);
	}
	if (ctx.rectOf("[data-tour='menu-queues']")) {
		await ctx.cursorTo("[data-tour='menu-queues']", { duration: 650 });
		await ctx.wait(1100);
	}

	// gran finale: o botão do próprio tutorial
	await ctx.waitFor("[data-tour='menu-tutorial']", 2000);
	await ctx.cursorTo("[data-tour='menu-tutorial']", { duration: 750 });
	await ctx.wait(500);
	await ctx.click("[data-tour='menu-tutorial']");

	// toast fixo (grande, embaixo no centro) — sem style de posição
	const toast = ctx.mount("toast", "[data-tour='main-content']", {
		icon: "🎧",
		text: "O tutorial fica sempre aqui!",
	});
	await ctx.wait(3400);
	ctx.unmount(toast);

	// encerra: remove o spotlight e estaciona o cursor num ponto neutro
	ctx.spotlight(null);
	await ctx.cursorTo(
		{ sel: "[data-tour='main-content']", ax: 0.45, ay: 0.4 },
		{ duration: 900 }
	);
}
